import { Dithering } from '@paper-design/shaders-react';
import { BookingCardFrontProps } from './BookingCardFrontCrafted';
import { getThemeCrafted } from './themesCrafted';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

export function BookingCardSkyRippleFront({
  businessName,
  businessInstagramHandle,
  businessLogoUrl,
  clientFullName,
  displayedVisits,
  memberSinceDate,
  serviceName,
  appointmentDate,
  appointmentTime,
  locationLabel,
  centerImageUrl,
  centerCustomText,
  onFlip,
}: BookingCardFrontProps) {
  const theme = getThemeCrafted('sky_ripple');

  return (
    <div
      className="relative w-full h-full cursor-pointer select-none overflow-hidden rounded-2xl"
      onClick={onFlip}
      style={{
        outline: `1px solid ${theme.borderColor}`,
      }}
    >
      {/* Animated Dithering Shader Background */}
      <Dithering
        speed={0.25}
        shape="ripple"
        type="random"
        size={4}
        scale={3.5}
        colorBack="#00000000"
        colorFront={theme.accentColor}
        className="absolute inset-0 w-full h-full"
        style={{ backgroundColor: theme.gradientFrom }}
      />

      {/* Content Layer */}
      <div className="relative z-10 w-full h-full flex flex-col p-6">
        {/* Header */}
        <div className="flex items-start justify-between mb-auto">
          <div className="flex items-center gap-3">
            {businessLogoUrl && (
              <Avatar className="w-10 h-10 border-2" style={{ borderColor: theme.borderColor }}>
                <AvatarImage src={businessLogoUrl} alt={businessName} />
                <AvatarFallback style={{ color: theme.textPrimary }}>
                  {businessName.charAt(0)}
                </AvatarFallback>
              </Avatar>
            )}
            <div>
              <div className="font-semibold" style={{ color: theme.textPrimary }}>
                {businessName}
              </div>
              {businessInstagramHandle && (
                <div className="text-sm" style={{ color: theme.textSecondary }}>
                  @{businessInstagramHandle}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Center Content */}
        <div className="flex-1 flex flex-col items-center justify-center text-center">
          {centerImageUrl ? (
            <img
              src={centerImageUrl}
              alt="Center graphic"
              className="w-32 h-32 object-contain mb-2"
            />
          ) : centerCustomText ? (
            <div className="text-4xl font-bold mb-2" style={{ color: theme.textPrimary }}>
              {centerCustomText}
            </div>
          ) : (
            <div className="space-y-2">
              <div className="text-2xl font-bold" style={{ color: theme.textPrimary }}>
                {clientFullName}
              </div>
              {serviceName && (
                <div className="text-lg" style={{ color: theme.textSecondary }}>
                  {serviceName}
                </div>
              )}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="mt-auto space-y-2">
          <div className="flex items-center justify-between text-sm">
            <span style={{ color: theme.textSecondary }}>
              {appointmentDate}
            </span>
            <span style={{ color: theme.textPrimary }} className="font-semibold">
              {appointmentTime}
            </span>
          </div>
          {locationLabel && (
            <div className="text-sm text-center" style={{ color: theme.textSecondary }}>
              {locationLabel}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
